module.exports = __webpack_public_path__ + "img/Pier_pass_config_desktop_transparent_2.38b1cf58.gif";